import { useNavigate } from "react-router-dom";
import BrandDetailsForm from "../../components/organisms/BrandDetailsForm";
import FormHeader from "../../components/molecules/forms/FormHeader";
import { BrandOnboardingStepsCopy } from "../../constants/constants";
import Button from "../../components/atoms/buttons/Button";
import BrandAddressForm from "../../components/organisms/BrandAddressForm";
import BrandProfileForm from "../../components/organisms/BrandProfileForm";
import BrandSubmissionSuccessForm from "../../components/organisms/BrandSubmissionSuccessForm";
import Loading from "../../components/atoms/Loading";
import { ArrowRight, OnboardingBackIcon } from "../../components/atoms/Icon";

function BrandOnboarding({ loading, currentStep, handleFormSubmit }: any) {
  const getForm = (step: Number) => {
    switch (step) {
      case 0:
        return <BrandDetailsForm />;
      case 1:
        return <BrandAddressForm />;

      case 2:
        return <BrandProfileForm />;

      case 3:
        return <BrandSubmissionSuccessForm />;
      default:
        return <p>Page not found.</p>;
    }
  };

  const { formHeading, icon, formDescription } = BrandOnboardingStepsCopy[currentStep];

  const navigate = useNavigate();

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="mx-auto max-w-[56rem] overflow-hidden p-2 pb-10 font-sora">
      {loading && <Loading />}
      {currentStep !== 3 && (
        <div className="w-fit max-w-full">
          <div className="mb-5 flex cursor-pointer items-center gap-2 font-sora text-sm font-semibold text-white">
            <button
              type="button"
              className="flex items-center justify-center space-x-2"
              onClick={handleBackButtonClick}
            >
              <span className="-mt-1">
                <OnboardingBackIcon />
              </span>
              <p>BACK</p>
            </button>
          </div>
          <FormHeader
            currentStep={currentStep}
            totalSteps={3}
            icon={icon}
            heading={formHeading}
            headingAdditionalClasses="text-5xl"
            subHeadingAdditionalClasses="max-w-xl"
            subHeading={formDescription}
          />
        </div>
      )}
      <div className="mt-8 max-w-full ">{getForm(currentStep)}</div>
      <div className="mt-8 flex justify-center gap-x-4 md:justify-start">
        {currentStep !== 3 && (
          <Button
            additionalClasses="xl:text-xs 2xl:text-sm xl:px-5 xl:py-2 2xl:px-7 2xl:py-3"
            text={currentStep === 2 ? "CREATE YOUR BRAND" : "NEXT "}
            icon={currentStep === 2 ? undefined : ArrowRight}
            onClick={handleFormSubmit}
            variant={currentStep === 2 ? "magnetiqSolid" : "rustPinkSolid"}
          />
        )}
      </div>
    </div>
  );
}

export default BrandOnboarding;
